module.exports = __webpack_public_path__ + "static/BitMart-84536beb951b61abb61bfe4763aa027c.png";